export default __webpack_public_path__ + "static/media/11.197f6297.svg";